import { render, staticRenderFns } from "./CollectionRepaymentIntentionAndNamePerformance.vue?vue&type=template&id=684d1d9b&scoped=true"
import script from "./CollectionRepaymentIntentionAndNamePerformance.vue?vue&type=script&lang=js"
export * from "./CollectionRepaymentIntentionAndNamePerformance.vue?vue&type=script&lang=js"
import style0 from "./CollectionRepaymentIntentionAndNamePerformance.vue?vue&type=style&index=0&id=684d1d9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684d1d9b",
  null
  
)

export default component.exports